export default __webpack_public_path__ + "static/ali-example-bef13af8de4b3e76b78239024aa4d289.png";